
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/set-informativi",
      function () {
        return require("private-next-pages/set-informativi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/set-informativi"])
      });
    }
  